import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { AccountDetailsForm } from "./components/AccountDetailsForm";
import { AccountInfo } from "./components/AccountInfo";
import { ApiTokenCard } from "./components/ApiTokenCard";
import { UpdatePasswordForm } from "./components/UpdatePasswordForm";
import Title from "../../components/Title";
import { pageHelp } from "../../components/help/pageHelp";

export default function Account() {
  return (
    <Box>
      <Title help={pageHelp.settings.help} helpItems={pageHelp.settings.items}>
        Settings
      </Title>
      <Grid container spacing={3} alignItems="flex-start">
        {/* Profile summary: a calm sticky sidebar */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ position: { md: "sticky" }, top: { md: 16 } }}>
            <AccountInfo />
          </Box>
        </Grid>
        {/* Settings stacked in one column so they line up consistently */}
        <Grid size={{ xs: 12, md: 8 }}>
          <Stack spacing={3}>
            <AccountDetailsForm />
            <UpdatePasswordForm />
            <ApiTokenCard />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
